import initMobileNav from './modules/mobile-nav';
import initAccordion from './modules/accordion';
import initSliders from './modules/sliders';
import initJuryFilter from './modules/jury-filter';
import initWinnersGalleryFilter from './modules/winners-gallery-filter';
import initVideoPlayer from './modules/video-player';
import initBlogFilter from './modules/blog-filter';

initMobileNav();
initAccordion();
initSliders();
initJuryFilter();
initWinnersGalleryFilter();
initVideoPlayer();
initBlogFilter();